import { FormInstance } from "@/shared/form/form";
import { useCreateCompanyDocumentConfirmationForActivePersons } from "./mode/use-create-company-document-confirmation-for-active-persons";
import { CreateCompanyDocumentConfirmationForActivePersonsForm } from "./ui/create-company-document-confirmation-for-active-persons-form";
import { FieldsType } from "./mode/types";

export function CreateCompanyDocumentConfirmationForActivePersons({
  documentId,
  form,
}: {
  documentId: string;
  form?: FormInstance<FieldsType>;
}) {
  const { create, loading } =
    useCreateCompanyDocumentConfirmationForActivePersons();

  return (
    <CreateCompanyDocumentConfirmationForActivePersonsForm
      layout="vertical"
      form={form}
      initialValues={{
        documentId,
      }}
      onFinish={create}
      disabled={loading}
    />
  );
}
